<template>
    <div class="report-view" ref="reportView">
        <div class="no-data" v-if="reportData == null">
            Creating report, please wait...
        </div>
        <div v-else class="report-data-container">
            <div class="report-data">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col">
                            <template v-if="hasData">
                                <div class="next-to-btn">
                                    Variable:
                                </div>
                                <div class="btn-group">
                                    <div class="dropdown">
                                        <button class="btn btn-secondary dropdown-toggle btn-sm" type="button" id="dropdownMenuButton" data-toggle="dropdown">
                                            {{ selVar == null ? 'Click to select' : selVar.name }}
                                        </button>
                                        <div class="dropdown-menu">
                                            <a v-for="item in getVarItems" :key="item.varid" class="dropdown-item" :data-varid="item.varid" :data-varname="item.name" :data-vargroup="item.varGroup" href="#" @click="varClicked">{{ item.name }}</a>
                                        </div>
                                    </div>
                                </div>
                                &nbsp;
                                <div class="btn-group">
                                    <div class="dropdown">
                                        <button class="btn btn-secondary dropdown-toggle btn-sm" type="button" data-toggle="dropdown">
                                            {{ 'Months: ' + monthsToDisplay }}
                                        </button>
                                        <div class="dropdown-menu">
                                            <a :data-num="num" :class="{ active: num == monthsToDisplay }" v-for="num in monthsToDisplayList" :key="num" class="dropdown-item" href="#" @click="monthToDisplay_Click">{{ num }}</a>
                                        </div>
                                    </div>
                                </div>                                                                
                            </template>
                            <template v-else>
                                <div class="alert alert-warning">
                                    <strong>Unable to produce report!</strong> Please make sure you have one or more data points for the current country/area.
                                </div>                                
                            </template>                            
                        </div>                        
                    </div>
                </div>

                <hr v-if="chartData != null" />

                <div class="container-fluid">

                    <h4 v-if="chartData != null" id="report-title" ref="reportTitleHeading">{{ chartData.pageTitle }}</h4>

                    <div class="row">
                        <div class="col">
                            <chart-view ref="forecastChart"></chart-view>
                        </div>                        
                    </div>
                    <hr v-if="chartData != null" />
                    <div class="row">                        
                        <div class="col">
                            <chart-view ref="historicalChart"></chart-view>
                        </div>                        
                    </div>
                </div>
            </div>
        </div> 
        <div class="close-button">
            <a href="#" @click="$emit('close')">&times;</a>
        </div>
    </div>
</template>

<script>
import logger from '@/lib/logger.js'
import ChartView from '@/components/ChartView.vue'
import ChartDataBuilder from '@/lib/ChartDataBuilder.js'

export default {
    name: 'ReportView',
    components: { 
        ChartView 
    },
    data() {
        return {
            reportData: null,
            chartData: null,
            selVar: null,
            monthsToDisplay : 0
        }
    },
    computed: {
        getVarItems() {
            let data = this.reportData.data
            let result = []
            if (Array.isArray(data) && data.length > 0) {
                data[0].forecastData.forEach((item) => {
                    result.push({
                        varid: item.varid,
                        name: item.name,
                        units: item.units,
                        varGroup: item.varGroup
                    })
                })
            }
            return result
        },
        hasData() {
            return this.getVarItems.length > 0
        },
        monthsToDisplayList() {
            if (this.reportData == null)
                return []

            let result = []
            for (let i = 1; i <= this.reportData.numMonths; i++)
                result.push(i)

            return result
        }
    },
    mounted() {
    },
    methods: {
        updateReport(data) {
            logger.log('ReportView::updateReport()', data)
            this.reportData = data
            this.monthsToDisplay = this.reportData.numMonths
        },
        monthToDisplay_Click(sender) {
            let monthsToDisplay = sender.target.dataset.num
            if (monthsToDisplay != null)
                this.monthsToDisplay = monthsToDisplay
            this.updateChartData()
        },
        clearReport() {
            logger.log('ReportView::clearReport()')
            this.reportData = null
            this.chartData = null
            this.selVar = null
        },
        updateChartData() {
            logger.log('ReportView::updateChartData()')
            
            let chartData = ChartDataBuilder.build(this.reportData, this.selVar.varGroup, this.monthsToDisplay)

            logger.log('Chart data', chartData)

            this.chartData = chartData

            this.$refs.forecastChart.updateData(chartData, chartData.forecastChart)
            this.$refs.historicalChart.updateData(chartData, chartData.historicalChart)
        },
        varClicked(e) {
            logger.log('ReportView::varClicked()')
            let varid = e.target.dataset.varid
            let name = e.target.dataset.varname
            let varGroup = e.target.dataset.vargroup

            let selVar = {
                varid: varid,
                name: name,
                varGroup: varGroup
            }            

            logger.log('Setting selVar', selVar)
            this.selVar = selVar
            
            this.updateChartData()
        }
    }
}
</script>

<style>
    .next-to-btn {
        display: inline-block;
        line-height: 35px;
        padding-right: 10px;
    }

    .report-view {
        position: absolute;
        width: 100%;
        height: 100%;
        position: relative;
        background-color: white;
    }

    .report-view .no-data {
        position: absolute;
        left: 0;
        right: 0;
        top: 50%;
        margin-top: -20px;
        height: 40px;
        line-height: 40px;
        text-align: center;
    }

    .report-data-container {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
    }

    .report-data {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        overflow-y: auto;
        
    }

    @media screen and (min-width: 601px) {
        .report-data {
            padding: 20px;
        }
    }

    @media screen and (max-width: 600px) {
        .report-data {
            padding: 5px;
        }
    }  

    .close-button {
        position: absolute;
        right: 30px;
        top: 10px;
    }  

    .close-button a {
        font-weight: bold;
        color: black;
        text-decoration: none;
        font-size: 18pt;
        padding: 5px;
    }

    .close-button a:hover {
        text-decoration: none;
    }

    #report-title.small {
        font-size: 14pt;
    }
</style>
